(() => {
  const popup = document.querySelector('[data-welcome-discount-popup]');
  if (!popup) return;

  const dismissedKey = 'lovecoveWelcomeDiscountDismissedAtV2';
  const subscribedKey = 'lovecoveWelcomeDiscountSubscribed';
  // backward compatible with legacy keys
  const legacyDismissedKey = 'vitraelleWelcomeDiscountDismissedAtV2';
  const legacySubscribedKey = 'vitraelleWelcomeDiscountSubscribed';
  const oneDay = 24 * 60 * 60 * 1000;
  const success = popup.querySelector('[data-welcome-discount-success]');
  const closeButton = popup.querySelector('[data-welcome-discount-close]');
  let previousFocus;

  const show = () => {
    previousFocus = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('welcome-discount-popup-open');
    requestAnimationFrame(() => popup.classList.add('is-visible'));
    (success || popup.querySelector('input[type="email"]') || closeButton)?.focus();
  };

  const hide = () => {
    localStorage.setItem(dismissedKey, String(Date.now()));
    popup.classList.remove('is-visible');
    document.body.classList.remove('welcome-discount-popup-open');
    window.setTimeout(() => {
      popup.hidden = true;
      previousFocus?.focus?.();
    }, 180);
  };

  closeButton?.addEventListener('click', hide);
  popup.addEventListener('click', (event) => {
    if (event.target === popup) hide();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) hide();
  });

  popup.querySelector('[data-welcome-discount-copy]')?.addEventListener('click', async (event) => {
    await navigator.clipboard.writeText('WELCOME10');
    event.currentTarget.textContent = 'Copied';
  });

  if (success) {
    localStorage.setItem(subscribedKey, 'true');
    show();
    return;
  }

  if (localStorage.getItem(subscribedKey) === 'true') return;
  const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
  if (dismissedAt && Date.now() - dismissedAt < oneDay) return;

  window.setTimeout(show, 3000);
})();
